import axios from 'axios';

import { getAuthHeader } from '@/entities/auth';
import { env } from '@/shared/lib';

const API_URL = env.VITE_API_URL;

export class IntegrationService {
  static getIntegrations() {
    return axios.get(`${API_URL}auth/integrations`, {
      headers: getAuthHeader(),
    });
  }

  static getStatus(type: 'google' | 'jira') {
    return axios.get(`${API_URL}auth/${type}/status`, {
      headers: getAuthHeader(),
    });
  }

  static create(type: 'google' | 'jira', payload: any) {
    return axios.post(`${API_URL}auth/${type}/create`, payload, {
      headers: getAuthHeader(),
    });
  }

  static update(type: 'google' | 'jira', payload: any) {
    return axios.put(`${API_URL}auth/${type}/update`, payload, {
      headers: getAuthHeader(),
    });
  }

  static delete(type: 'google' | 'jira') {
    return axios.delete(`${API_URL}auth/${type}/delete`, {
      headers: getAuthHeader(),
    });
  }

  static getGoogleOauthUrl(redirect_url: string) {
    return axios.get(`${API_URL}auth/google/oauth-url?redirect_url=${redirect_url}`, {
      headers: getAuthHeader(),
    });
  }
}
